'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Down;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bcPropTypes = require('@bibliocommons/bc-prop-types');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/* eslint-disable max-len */

function Down(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$width = _ref.width,
      width = _ref$width === undefined ? 16 : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === undefined ? 16 : _ref$height;

  return _react2.default.createElement(
    'svg',
    {
      xmlns: 'http://www.w3.org/2000/svg',
      'aria-hidden': true,
      focusable: 'false',
      className: 'icon-svg-sort-down ' + className,
      width: width,
      height: height,
      viewBox: '0 0 16 16' },
    _react2.default.createElement('path', { fill: 'currentColor', fillRule: 'evenodd', d: 'M14 8c0 1.08-.27 2.08-.81 3-.54.92-1.27 1.65-2.19 2.19-.92.54-1.92.81-3 .81s-2.08-.27-3-.81A6.063 6.063 0 0 1 2.81 11C2.27 10.08 2 9.08 2 8s.27-2.08.81-3C3.35 4.08 4.08 3.35 5 2.81 5.92 2.27 6.92 2 8 2s2.08.27 3 .81c.92.54 1.65 1.27 2.19 2.19.54.92.81 1.92.81 3zm-3.484-.702l-1.742 1.84V4.71a.56.56 0 0 0-.17-.412.56.56 0 0 0-.41-.169h-.388a.56.56 0 0 0-.41.17.56.56 0 0 0-.17.41v4.428L5.484 7.298a.574.574 0 0 0-.424-.169c-.169 0-.31.056-.423.17l-.266.266a.56.56 0 0 0-.17.41.56.56 0 0 0 .17.412l3.218 3.194A.56.56 0 0 0 8 11.75a.56.56 0 0 0 .411-.17l3.218-3.193a.56.56 0 0 0 .17-.411.56.56 0 0 0-.17-.411l-.266-.267a.574.574 0 0 0-.423-.169c-.17 0-.311.056-.424.17z' })
  );
}

Down.propTypes = _bcPropTypes.iconShape;


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Sort/Down.js
// module id = 319
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15